import { fetchExactagCustomerData } from "./api"
import * as exactag from "@otto-ec/online-marketing/exactag"
import { onCustomerSessionRefresh } from "@otto-ec/fti-customer-session-frontend"
import { type ExactagData } from "@otto-ec/online-marketing/exactag"

export function trackCustomerData() {
    void exactag.registerVerticalDataCallback("customerData", async (): Promise<ExactagData> => {
        return new Promise<ExactagData>((resolve) => {
            onCustomerSessionRefresh.subscribe(
                async () => {
                    try {
                        const data = await fetchExactagCustomerData()
                        resolve(data)
                    } catch (error) {
                        console.error("Failed to fetch customer's exactag data:", error)
                        resolve({})
                    }
                },
                { once: true },
            )
        })
    })
}

trackCustomerData()
